import { useContext } from 'react';
import { Checkbox } from '@fluentui/react-components';

import DocumentContext from '../../../contexts/DocumentContext.context';
import useEditorActive from '../../../hooks/useEditorActive.hook';
import { findSelectedField } from '../formField/formFieldHelpers';
import { setFieldSettings, TFieldSettings } from './fieldSettings';
import FieldTextSettings from './FieldTextSettings';

type TProps = {
  nodeName: string;
};

/** Label, Description and Required in the popup of the selected field; a card shows its own. */
const FieldSettingsControls = ({ nodeName }: TProps) => {
  const { editor } = useContext(DocumentContext);
  const field = useEditorActive((current) => findSelectedField(current.state, nodeName));

  if (!field) return null;

  const update = (patch: Partial<TFieldSettings>) => setFieldSettings(editor, field.pos, patch);

  return (
    <div className="flex flex-col gap-2">
      <FieldTextSettings editor={editor} field={field.node} onSettingsChange={update} />
      <Checkbox
        checked={field.node.attrs.required}
        label="Required"
        onChange={(_, data) => update({ required: data.checked === true })}
      />
    </div>
  );
};

export default FieldSettingsControls;
